import utils from '../utils/utils'
import anime from '../libs/anime'
import Hammer from '../libs/hammer'
import globalVar from '../utils/globalVar'

class List {
  constructor() {
    const tablet = window.matchMedia("(max-width: 1040px)");
    let cache = {};
    let timerHero;
    let indexHero = 0;
    let scrollPos = 0;
    let initFunc = () => {
      initCache();
      registerEvents();
      hideEmpty();
    }

    let initCache = () => {
      cache.hero = document.querySelector('section.hero');
      if(cache.hero.querySelector('.slider_nav')) {
        cache.heroSlider = cache.hero.querySelector('.slider');
        cache.heroSlides = cache.hero.querySelectorAll('.slider .slide');
        cache.heroSliderNav = cache.hero.querySelectorAll('.slider_nav .dot');
      }
      cache.filters = document.querySelectorAll('.filter_inner .filter_tag');
      cache.filterDropBtn = document.querySelector('.drop_filter');
      cache.filterDrop = document.querySelector('.filter_inner');
      cache.scroll = document.querySelectorAll('a.scroll');
      cache.letterSection = document.querySelectorAll('.container_posts .letter_wrap');
    };

    let registerEvents = () => {
      if(cache.hero.querySelector('.slider_nav')) {
        for (let i = 0; i < cache.heroSliderNav.length; i++) {
          cache.heroSliderNav[i].addEventListener("click", function() {
            heroSlide(this.dataset.index);
          });
        }
        timerHero = setInterval(timerHeroSlide, 6000);
        let hammertime = new Hammer(cache.hero);
        hammertime.on('swipe', function(ev) {
          if(ev.direction == 2) {
            if(indexHero == cache.heroSlides.length-1) {
              indexHero = 0;
            } else {
              indexHero++;
            }
            heroSlide(indexHero);
          }
          if(ev.direction == 4) {
            if(indexHero == 0) {
              indexHero = cache.heroSlides.length-1;
            } else {
              indexHero--;
            }
            heroSlideRigth(indexHero);
          }
        });
      }

      for (var i = 0; i < cache.filters.length; i++) {
        cache.filters[i].addEventListener("click", filter);
      }
      for (var i = 0; i < cache.scroll.length; i++) {
        cache.scroll[i].addEventListener("click", scrollTo);
      }

      cache.filterDropBtn.addEventListener("click", openFilter);

      window.addEventListener('scroll', animeNavList);
    };


    let heroSlide = function(index) {
      clearInterval(timerHero);
      indexHero = index;
      let current = cache.heroSlider.querySelector('.slide.active');
      let currentDot = cache.hero.querySelector('.slider_nav .dot.active');
      let target = cache.heroSlides[index];
      let targetDot = cache.heroSliderNav[index];

      current.classList.remove('active');
      currentDot.classList.remove('active');
      target.classList.add('active');
      targetDot.classList.add('active');

      anime({
        targets: current,
        scale: [0.9],
        duration: 350,
        easing: 'easeOutCubic',
        delay: 75,
        complete: function() {
          anime({
            targets: current,
            translateX: ['0%', '-150%'],
            duration: 600,
            easing: 'easeOutCubic',
            complete: function() {
              current.style.opacity = 0;
            }
          });
        }
      });

      anime({
        targets: target,
        scale: [0.9],
        duration: 350,
        easing: 'easeOutCubic',
        complete: function() {
          target.style.opacity = 1;
          anime({
            targets: target,
            translateX: ['150%', '0%'],
            duration: 600,
            easing: 'easeOutCubic',
            complete: function() {
              timerHero = setInterval(timerHeroSlide, 6000);
              anime({
                targets: target,
                scale: [1],
                duration: 400,
                easing: 'easeOutCubic',
              });
            }
          });
        }
      });
    }

    let heroSlideRigth = function(index) {
      clearInterval(timerHero);
      indexHero = index;
      let current = cache.heroSlider.querySelector('.slide.active');
      let currentDot = cache.hero.querySelector('.slider_nav .dot.active');
      let target = cache.heroSlides[index];
      let targetDot = cache.heroSliderNav[index];

      current.classList.remove('active');
      currentDot.classList.remove('active');
      target.classList.add('active');
      targetDot.classList.add('active');

      anime({
        targets: current,
        scale: [0.9],
        duration: 350,
        easing: 'easeOutCubic',
        delay: 75,
        complete: function() {
          anime({
            targets: current,
            translateX: ['0%', '150%'],
            duration: 600,
            easing: 'easeOutCubic',
            complete: function() {
              current.style.opacity = 0;
            }
          });
        }
      });

      anime({
        targets: target,
        scale: [0.9],
        duration: 350,
        easing: 'easeOutCubic',
        complete: function() {
          target.style.opacity = 1;
          anime({
            targets: target,
            translateX: ['-150%', '0%'],
            duration: 600,
            easing: 'easeOutCubic',
            complete: function() {
              timerHero = setInterval(timerHeroSlide, 6000);
              anime({
                targets: target,
                scale: [1],
                duration: 400,
                easing: 'easeOutCubic',
              });
            }
          });
        }
      });
    }

    let timerHeroSlide = function() {
      if(indexHero == cache.heroSlides.length-1) {
        indexHero = 0;
      } else {
        indexHero++;
      }
      heroSlide(indexHero);
    }

    let filter = function() {
      document.querySelector('.filter_tag.active').classList.remove('active');
      this.classList.add('active');

      let active_posts = document.querySelectorAll('.letter_wrap .list a');

      for (var i = 0; i < active_posts.length; i++) {
        let post = active_posts[i];
        if(this.dataset.filter !== 'cat-all') {
          if(!post.classList.contains(this.dataset.filter)) {
            post.classList.add('hide');
            anime({
              targets: post,
              opacity: 0,
              height: 0,
              duration: 300,
              easing: 'easeInOutCubic',
              complete: function() {
                post.style.display = 'none';
                hideEmpty();
              }
            });
          } else if(post.classList.contains(this.dataset.filter) && post.classList.contains('hide')) {
            post.style.display = 'block';
            post.style.height = 'auto';
            post.classList.remove('hide');
            anime({
              targets: post,
              opacity: 1,
              duration: 300,
              easing: 'easeInOutCubic',
            });
          }
        }
        else {
          if(post.classList.contains('hide')) {
            post.style.display = 'block';
            post.style.height = 'auto';
            post.classList.remove('hide');
            anime({
              targets: post,
              opacity: 1,
              duration: 300,
              easing: 'easeInOutCubic',
              complete: function() {
                hideEmpty();
              }
            });
          }
        }
      }


      if(tablet.matches) {
        openFilter();
        cache.filterDropBtn.querySelector('.txt').innerHTML = this.innerHTML;
      }
    }

    let openFilter = function() {
      if(cache.filterDropBtn.classList.contains('open')) {
        anime({
          targets: cache.filterDropBtn.querySelector('svg'),
          rotate: 0,
          duration: 400,
          easing: 'easeInOutCubic',
        });
        anime({
          targets: cache.filterDrop,
          height: 0,
          duration: 400,
          easing: 'easeInOutCubic',
          complete: function() {
            cache.filterDrop.style.display = "none";
            cache.filterDropBtn.classList.remove('open');
          }
        });
      } else {
        cache.filterDrop.style.display = "block";
        cache.filterDrop.style.height = "auto";
        let height = cache.filterDrop.offsetHeight;
        cache.filterDrop.style.height = 0;
        anime({
          targets: cache.filterDropBtn.querySelector('svg'),
          rotate: -180,
          duration: 400,
          easing: 'easeInOutCubic',
        });
        anime({
          targets: cache.filterDrop,
          height: [0,height],
          duration: 400,
          easing: 'easeInOutCubic',
          complete: function() {
            cache.filterDropBtn.classList.add('open');
          }
        });
      }
    }

    let scrollTo = function(e) {
      document.querySelector('body').classList.add('scroll');
      e.preventDefault();
      var target = document.querySelector(this.getAttribute("href"));
      anime({
        targets: globalVar.scrollElement,
        scrollTop: (globalVar.scrollElement.scrollTop+target.getBoundingClientRect().top-150),
        duration: 400,
        easing: 'easeOutQuad',
        complete: function () {
          document.querySelector('body').classList.remove('scroll');
        }
      });
    }



    function hideEmpty() {
      for (var i = 0; i < cache.scroll.length; i++) {
        let href = String(cache.scroll[i].href);
        let id = href.split('#')[1];
        let container = document.querySelector('#'+id);
        if(!container) {
          cache.scroll[i].classList.add('not-active');
        }
        else {
          let item = container.querySelectorAll('.list a');
          let hide = true;
          for (var ii = 0; ii < item.length; ii++) {
            if(!item[ii].classList.contains('hide')) {
              hide = false;
            }
          }
          if(hide) {
            cache.scroll[i].classList.add('not-active');
            container.style.display = "none";
          } else {
            if(cache.scroll[i].classList.contains('not-active')) {
              cache.scroll[i].classList.remove('not-active');
            }
            container.style.display = "flex";
          }
        }
      }
    }

    let animeNavList = function() {
      let up = false;
      if(scrollPos > window.pageYOffset) {
        up = true;
      }
      scrollPos = window.pageYOffset;

      for (let i = 0; i < cache.letterSection.length; i++) {
        if((scrollPos+200 > getOffsetTop(cache.letterSection[i])) && (!cache.letterSection[i].classList.contains('active')) && (scrollPos+200 < (getOffsetTop(cache.letterSection[i])+cache.letterSection[i].offsetHeight))) {
          cache.letterSection[i].classList.add('active');
          document.querySelector('.scroll.active').classList.remove('active');
          document.querySelector('.container_posts .letter_wrap.active').classList.remove('active');
          document.querySelector('.scroll.link-'+cache.letterSection[i].id).classList.add('active');
        }
      }

    }

    function getOffsetTop(element) {
      let offsetTop = 0;
      while(element) {
        offsetTop += element.offsetTop;
        element = element.offsetParent;
      }
      return offsetTop;
    }
    initFunc();
  };
}
export { List }
